module.exports = __webpack_public_path__ + "static/media/cart_logo.245e698a.png";